import { Component } from '@theme/component';

/**
 * @typedef {Object} KlaviyoFormRefs
 * @property {HTMLFormElement} form - Form
 * @property {HTMLElement} formContent - Form wrapper
 * @property {HTMLElement} success - Success message
 * @property {HTMLElement} error - Error message
 */

/**
 * A custom element that manages the showing and hiding excess content items
 *
 * @extends {Component<KlaviyoFormRefs>}
 */

class KlaviyoForm extends Component {
  requiredRefs = ['form', 'formContent', 'success', 'error'];

  connectedCallback() {
    super.connectedCallback();
    const { swiper } = this.refs;
  }

  #disabledClass = 'hidden';

  /**
   * @param {{ preventDefault: () => void; stopPropagation: () => void; }} event
   */
  submit(event) {
    event.preventDefault();
    event.stopPropagation();

    const { form, formContent, success, error } = this.refs;
    const listID = form?.dataset?.listId;
    if (!listID) return;

    if (!form.checkValidity()) return;
    let attributes = Object.fromEntries(new FormData(form));

    // @ts-ignore
    attributes.properties = {};
    for (const [key, value] of Object.entries(attributes)) {
      if (key.includes('properties[')) {
        delete attributes[key];
        const prop = key.replace('properties[', '').replace(']', '');
        // @ts-ignore
        attributes.properties[prop] = value;
      }
    }

    const options = {
      method: 'POST',
      headers: { revision: '2024-02-15', 'content-type': 'application/json' },
      body: JSON.stringify({
        data: {
          type: 'subscription',
          attributes: {
            profile: {
              data: {
                type: 'profile',
                attributes: attributes
              }
            }
          },
          relationships: { list: { data: { type: 'list', id: listID } } }
        }
      })
    };

    fetch(form.action, options)
      .then((response) => {
        if (response?.ok) {
          form.classList.add(this.#disabledClass);
          formContent.classList.add(this.#disabledClass);
          success.classList.remove(this.#disabledClass);
          error.classList.add(this.#disabledClass);
        } else {
          form.classList.add(this.#disabledClass);
          formContent.classList.add(this.#disabledClass);
          success.classList.add(this.#disabledClass);
          error.classList.remove(this.#disabledClass);
        }
      })
      .catch((err) => {
        form.classList.add(this.#disabledClass);
        formContent.classList.add(this.#disabledClass);
        success.classList.add(this.#disabledClass);
        error.classList.remove(this.#disabledClass);
        console.error(err);
      });
  }
}

if (!customElements.get('klaviyo-form')) {
  customElements.define('klaviyo-form', KlaviyoForm);
}
